
import { computed, defineComponent, Ref, ref } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    components: {
        loader: Loader,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'button',
        },
        hint: {
            type: String,
            default: null,
        },
        hintColor: {
            type: String,
            default: 'text-white',
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const hintref = ref(null) as Ref<null | HTMLElement>

        const emitClick = (event: MouseEvent) => {
            if (props.loading || props.disabled) return
            emit('click', event)
        }

        const hintHalfWidth = computed(() => {
            if (!hintref.value) return 0
            return hintref.value.offsetWidth / 2
        })

        return { emitClick, hintref, hintHalfWidth }
    },
})
